module.exports = __webpack_public_path__ + "img/xing.ea44663a.png";